import { render, staticRenderFns } from "./CustomNotificationDropdown.vue?vue&type=template&id=64edd150"
import script from "./CustomNotificationDropdown.vue?vue&type=script&lang=js"
export * from "./CustomNotificationDropdown.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports